
export const Storecolumns = [
  { 
    field: "_id", 
    header: "User Id",
    accessor: (row,handleCellClick) => (
        <>
          <div onClick={()=>handleCellClick(row,"_id")}  className="cursor-pointer text-blue-600 hover:text-blue-800">
            <p>{row?._id}</p>            
          </div>
        </>
      ),

   },
  { 
    field: "Store Name", 
    header: "name",
    accessor: (row) => (
        <>
          <div   className="cursor-pointe">
            
            <p className="truncate w-[8rem]">{row?.first_name||row?.orderDetails[0]?.product?.name}</p>            
          </div>
        </>
      ),

   },
  
  { field: "email", header: "Email",
    accessor: (row) => (
      <>
        <div>          
          <p className="px-2">
           {row?.email}
          </p>
        </div>
      </>
    ),
   },
  { field: "phone_number", header: "Contact No",
    accessor: (row) => (
      <>
        <div>          
          <p className="px-2">
           {row?.phone_number}
          </p>
        </div>
      </>
    ),
   },
  
  { field: "average_rating", header: "Rating",
    accessor: (row) => (
      <>
        <div>          
          <p className="px-2">
           {row?.average_rating}
          </p>
        </div>
      </>
    ),
   },
   { field: "address", header: "Address",
    accessor: (row) => (
      <>
        <div>          
          <p className="px-2">
           {row?.address}
          </p>
        </div>
      </>
    ),
   },
  
];

export const searchBy = {
    filterType: "Sort By",
    inputName: "search_by",
    options: [
      {
        name: "Descending ",
        code: "desc",
      },
      {
        name: "Ascending",
        code: "asc",
      },
    ],
  };
  
  export  const filters = [
    {
      filterType: "Delivery Type",
      inputName: "order_type",
      options: [
        {
          name: "Local delivery",
          code: "LOCAL DELIVERY",
        },
        {
          name: "Intercity delivery",
          code: "INTERCITY DELIVERY",
        },
      ],
    },
   
  ]
  
  export const canlenderFilter={
    filterType:"Order Date",
    inputName:"order_date",  
    maxDate :new Date()
  }
  
  
  
  
   
  


export default {  
    filters:filters,
    SearchBy:searchBy  ,
    // WeekRange:WeekRange,
    // MonthRange:MonthRange,
    canlenderFilter:canlenderFilter,    
  }